import Client from './client';

export default class ItemClassifications extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  postPredict(options = {}) {
    return this.makeRequest(`${this.host}/predict`, {
      ...options,
       method: 'POST',
    });
  }

  postV2AndPredict(options = {}) {
    return this.makeRequest(`${this.host}/v2/predict`, {
      ...options,
       method: 'POST',
    });
  }

}
